/** Client-side navigation. */
import { browser } from '$app/environment';
import { goto } from '$app/navigation';

/** TODO(mc, 2023-11-27): remove URLs from this list as they are replaced with Svelte */
const EXTERNAL_PAGES = new Set(['/', '/robots']);

/** Trigger a navigation to an internal or external page. */
export const navigate = async (url: string): Promise<void> => {
  if (browser) {
    if (EXTERNAL_PAGES.has(url)) {
      navigateExternal(url);
    } else {
      return goto(url);
    }
  }
};

/** Trigger a navigation to an external page. */
export const navigateExternal = (url: string): void => {
  if (browser) {
    window.location.assign(url);
  }
};

/** Trigger a navigation to a page in a new tab. */
export const navigateInNewTab = (url: string): void => {
  if (browser) {
    window.open(url, '_blank');
  }
};
